export enum ToastVariant {
  "SUCCESS" = "success",
  "ERROR" = "danger",
}

export interface IToastMessage {
  message: string;
  uniqueId?: string;

  variant: any;
  delay?: number;
  iconSrc?: string;
  redirectLink?: string;
  linkText?: string;
}
